class LookupsService {
    static $inject = ['apiFactory'];

    constructor(apiFactory) {
        this.apiFactory = apiFactory;

        // data for dropdowns
        // let productTypesPromise;
        // this.getProductTypes = () => productTypesPromise || (productTypesPromise = this.apiFactory.create('api/v1/product-types').all());
    }
}

angular
    .module('app')
    .service('lookupsService', LookupsService);
